<template>
  <!--<div class="order pt-4"> 
    <div>Order: {{ moment(order.orderDate).format("dddd, Do") }} :: {{order.items.length}} Items :: {{order.total}}</div>
  <ul>-->
  <!-- example of itterating the items  :: NOTE the qty * price = total (for the item)-->
  <!-- <li style="list-style:none" v-for="(item,index) in order.items" :key="index">
          {{ item.qty }} {{ item.title }}   {{ item.price * item.qty }}
      </li>
    </ul>
  </div>-->
  <b-col sm="2 col-bg width-20" :class="orderKey">
    <b-row>
      <b-col class="week-title" :class="days[orderKey].toLowerCase()" sm="12">{{ days[orderKey].toUpperCase()}}</b-col>
      <b-col class="week-content pt-3 pb-3" sm="12">
        <div v-if="order">
          <div class="order-detail">
            <!-- <div class="title">
              <span>Order Detail</span>
            </div>-->
            <!-- <hr>
            <div class="order-content d-flex">
              <div class="label pr-2">Date:</div>  
              {{ moment(order.orderDate).format("Do") }}
            </div>-->

            <!-- NOTE: although this field isn't necessary it may be interesting -->

            <div class="order-content d-flex">
              <div class="label">{{ numItems }} Items Ordered</div>
            </div>
            <div class="order-content d-flex pb-2">
              <div class="label" v-if="showPrice">Grand Total: {{order.total}}</div>
            </div>
          </div>
          
          <!-- <hr> -->
          <!-- <div class="item-details-title">
              <span>Items Detail</span>
          </div>-->

          <div v-for="(item,index) in order.items" :key="index">
            <div class="item-detail">
              <div class="item-content d-flex">
                <div class="label pl-2 text-left">({{item.qty}}) {{ item.title }}</div>
              </div>

              <!-- NOTE: I put this here so you have an idea of how the description would lay in; I didn't mess with your css :) -->
              <div style="white-space:pre-line;text-align:left;" class="pl-2">{{item.description}}</div>

              <!-- <div class="item-content d-flex">
                  <div class="label pr-2">Qty:</div>  
                  {{ item.qty }}
              </div>-->

              <!-- NOTE: These next two segments are optional -->
              <!-- if showing price, doesn't matter if the price is 0.00, some items will be zero priced -->

              <div class="item-content d-flex" v-if="showPrice">
                <div class="label pr-2">Price:</div>
                {{ item.price }}
              </div>
              <div class="item-content d-flex" v-if="showPrice">
                <div class="label pr-2">Total Price:</div>
                {{ item.price * item.qty }}
              </div>
            </div>
          </div>

          <!-- <div class="d-flex grand-total"> 
            <div class="label pr-2">Grand Total:</div>  
            {{order.total}}
          </div>-->
        </div>
        <div class="no-order" v-else>No order</div>
      </b-col>
    </b-row>
  </b-col>
</template>
<script>
import Moment from "moment";

export default {
  name: "OrderCalendarCard",
  components: {
  },
  data() {
    return {
      days: {
        'Mon': 'Monday',
        'Tue': 'Tuesday',
        'Wed': 'Wednesday',
        'Thu': 'Thursday',
        'Fri': 'Friday',
      },
      selectedDate: {}
    };
  },
  props: {
    order: { type: Object, default: () => {} },
    orderKey: { type: String },
    showPrice: { type: Boolean, default: false }
  },
  computed: {
    numItems() {
      // NOTE: the # of items on an order is the sum of the qty field
      return (this.order) ? this.order.items.reduce((qty, item) => qty + item.qty, 0) : 0;
    }
  },
  methods: {
    moment(d) {
      return Moment(d);
    }
  }
};
</script>
<style lang="scss" scoped>
//
//  NOTE: et's use these for the day colors since they would then match what the parents see when ordering
// -------------------[ mySchool Ordering Day Colors ]---
// mon rgb(237,50,55)
// tue rgb(57,166,194)
// wed rgb(94,54,150)
// thu rgb(31,177,133)
// fri rgb(127,184,71)
//
.col-bg {
  &.Mon {
    background: rgba(237, 50, 55, 0.2);
  }

  &.Tue {
    background: rgba(57, 166, 194, 0.2);
  }

  &.Wed {
    background: rgba(94, 54, 150, 0.2);
  }

  &.Thu {
    background: rgba(31, 177, 133, 0.2);
  }

  &.Fri {
    background: rgba(127, 184, 71, 0.2);
  }
}
.week-content {
  color: #333;

  .label {
    font-weight: 600;
  }

  .no-order {
    font-weight: 600;
  }

  hr {
    margin-left: -15px;
    margin-right: -15px;
  }

  .item-details-title {
    font-weight: 600;
    font-size: 17px;
    margin-bottom: 12px;
  }

  .order-detail {
    .title {
      font-weight: 600;
      font-size: 17px;
      margin-bottom: 12px;
    }

    .order-content {
      margin-bottom: 2px;
    }
  }

  .item-detail {
    border-top: 1px solid rgba(0, 0, 0, 0.1);
    margin-left: -15px;
    margin-right: -15px;
    padding: 10px;

    .item-content {
      margin-bottom: 2px;
    }
  }
}

@media only screen and (min-width: 575px) {
  .width-20 {
    max-width: 20%;
    width: 20%;
    flex: 0 0 20%;
  }
}

</style>
